<template>
	<div>
		<p class="typo-subtitle mb-4">
			Overview data
		</p>
		<div class="container-status">
			<BaseLoading v-if="isLoading" />
			<template v-else>
				<div class="container-status-item from-itec">
					<span class="container-status-item-title">
						Total SKUs from ITEC
					</span>
					<span class="container-status-item-value">
						{{ fromItec }}
					</span>
				</div>
				<div class="container-status-item online-stock">
					<span class="container-status-item-title">
						Total online stock (QTY)
					</span>
					<span class="container-status-item-value">
						{{ onlineStock }}
					</span>
				</div>
				<div class="container-status-item active-sku">
					<span class="container-status-item-title">
						Active SKU
					</span>
					<span class="container-status-item-value">
						{{ activeSku }}
					</span>
				</div>
				<div class="container-status-item inactive-sku">
					<span class="container-status-item-title">
						Inactive SKU
					</span>
					<span class="container-status-item-value">
						{{ inactiveSku }}
					</span>
				</div>
				<div class="container-status-item eol-sku">
					<span class="container-status-item-title">
						EOL SKU
					</span>
					<span class="container-status-item-value">
						{{ eolSku }}
					</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DashboardOverview',

	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		fromItec: {
			type: String,
			default: null,
		},
		onlineStock: {
			type: String,
			default: null,
		},
		activeSku: {
			type: String,
			default: null,
		},
		inactiveSku: {
			type: String,
			default: null,
		},
		eolSku: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
.container-status {
	width: 100%;
	height: 88px;
	padding: rem(16);
	display: flex;
	background-color: $color-white;
	border-radius: 4px;
	box-shadow: $showdow-section;

	&-item {
		position: relative;
		display: flex;
		flex: 1;
		flex-direction: column;
		height: rem(56);
		padding-left: rem(16);

		&.from-itec {
			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: rem(4);
				height: 100%;
				background-color: $color-supernova;
				border-radius: 2px;
			}
		}

		&.online-stock {
			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: rem(4);
				height: 100%;
				background-color: $color-supernova;
				border-radius: 2px;
			}
		}

		&.active-sku {
			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: rem(4);
				height: 100%;
				background-color: $color-success;
				border-radius: 2px;
			}
		}

		&.inactive-sku {
			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: rem(4);
				height: 100%;
				background-color: $color-alert;
				border-radius: 2px;
			}
		}

		&.eol-sku {
			&::after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: rem(4);
				height: 100%;
				background-color: $color-gray-400;
				border-radius: 2px;
			}
		}

		&-title {
			margin-top: rem(3);
			font-size: rem($font-size-label);
			color: $color-black-90;
			font-weight: $font-weight-bold;
		}

		&-value {
			font-size: rem($font-size-h4);
			color: $color-black-90;
			font-weight: $font-weight-bold;
		}
	}
}

::v-deep {
	.loading-container {
		justify-content: center;
		width: 100%;
	}

	.spinner-wrapper {
		height: rem(60);
		margin: 0 auto;
		width: rem(60);
	}
}
</style>
